var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_1314_4)","key":0},React.createElement("path",{"d":"M1 1L6 5L11 1","stroke":"#44505F","strokeLinecap":"round","strokeLinejoin":"round"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_1314_4"},React.createElement("rect",{"width":"6","height":"12","fill":"white","transform":"matrix(0 1 -1 0 12 0)"})))]);
}

Chevron.defaultProps = {"width":"12","height":"6","viewBox":"0 0 12 6","fill":"none"};

module.exports = Chevron;

Chevron.default = Chevron;
